import { useParams } from 'react-router-dom'
import { toast, Flip } from 'react-toastify'
import { AppContext } from '../../AppContext'
import { useContext, useState, useEffect } from 'react'

const CreateAgent = () => {
    const { action, id } = useParams()
    const [ post, setPost ] = useState(null)
    const { setLoading, hostBase } = useContext(AppContext)
    
    const updateField = (e) => {
        let _post = {...post}
        if(!_post['email'])
            _post['email'] = ''
        if(!_post['phone'])
            _post['phone'] = ''
        _post[e.target.name] = e.target.value
        setPost(_post)
    }
    const doUpdate = (e) => {
        e.preventDefault()
        setLoading(true)
        let formData = new FormData()
        for(let key in post)
            formData.append(key, post[key])
        const token = localStorage.getItem('userToken')
        fetch(`${hostBase}/api/agent/update/?token=${token}`, { method: 'POST', body: formData })
            .then(res => res.json())
            .then((data) => {
                if(data?.error)
                    toast.error(data.error, { theme: "colored", transition: Flip })
                else{
                    let _post = {...post}
                    if(!id){
                        delete _post.name
                        delete _post.email
                        delete _post.phone
                    }
                    setPost(_post)
                    toast.success(data.state, { theme: "colored", transition: Flip })
                }
            })
            .catch((e) => { toast.error('Ocurrió un error al intentar crear el comercial.', { theme: "colored", transition: Flip }) })
            .finally(() => setLoading(false))
    }
    
    useEffect(() => {
        if(post !== null && !id)
            setPost(null)
        if(post === null && id){
            setLoading(true)
            const token = localStorage.getItem('userToken')
            fetch(`${hostBase}/api/agent/get/${id}/?token=${token}`)
                .then(res => res.json())
                .then((data) => {
                    if(data.length !== 0)
                        setPost(data)
                    else
                        toast.error('No se encontró información para este comercial.', { theme: "colored", transition: Flip })
                })
                .catch((e) => { toast.error('Ocurrió un error al intentar traer la información del comercial.', { theme: "colored", transition: Flip }) })
                .finally(() => setLoading(false))
        }
    }, [])
    
    return (
        <form onSubmit={doUpdate}>
            <input type="hidden" name="agid" value={post?.agid || ''} />
            <h2>{action == 'modificar' ? 'Modificación' : 'Creación'} de comercial.</h2>
            <div>
                <label htmlFor="name">Nombre</label>
                <input type="text" name="name" value={post?.name || ''} onChange={updateField} required />
            </div>
            <div>
                <label htmlFor="email">Correo electrónico</label>
                <input type="email" name="email" value={post?.email || ''} onChange={updateField} />
            </div>
            <div>
                <label htmlFor="phone">Teléfono / Celular</label>
                <input type="text" name="phone" value={post?.phone || ''} onChange={updateField} />
            </div>
            <button type="submit">{action == 'modificar' ? 'Modificar' : 'Crear'} comercial</button>
        </form>
    )
}
export default CreateAgent